<template>
  <BoardView :title="site.name">
    <FormValidation @submit="save">
      <FormSite :site.sync="site" />
      <Btn v-if="hasRole('>=MODERATOR')" class="info" :isLoading="isSaving" type="submit">
        {{ $t('submit') }}
      </Btn>
    </FormValidation>
  </BoardView>
</template>

<script>
import { actions, getters } from '@utils'
import BoardSingle from '@mixins/BoardSingle'
import FormSite from '@forms/FormSite'

export default {
  mixins: [BoardSingle('site', {
    factory() {
      const { query } = this.$store.getters
      return {
        siteUsers: query('siteUser', { siteId: this.recordId })
          .map(({ userId }) => ({ userId })),
      }
    },
  })],
  components: { FormSite },
  computed: getters(),
  methods: actions('FETCH_SITE_USER'),
  async created() {
    this.LOAD(async () => this.FETCH_SITE_USER({ siteId: this.recordId }))
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "submit": "Update"
  }
}
</i18n>
